import React, { Component } from 'react';
import { connect } from 'react-redux';
import "./home.css";
import { Container } from "mdbreact";
import Slideshow from "./slideshow";
import CategoryLogos from "./categorylogos";
import LastAds from "./lastads";
import MostPupular from "./mostpupular";
import HomeTitle from "./hometitle";
import DownloadApp from "./downloadapp";


class Home extends Component {

    render() {
        return (
            <div className="pt-5">

                <Slideshow />
                <Container>
                    <CategoryLogos />
                    <HomeTitle title={'جدیدترین آگهی ها'} />
                    <LastAds />
                    <HomeTitle title={'محبوبترین ها'} />
                    <MostPupular />
                    <DownloadApp />
                </Container>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { categories: state.categories };
}

export default connect(
    mapStateToProps, null
)(Home);



// WEBPACK FOOTER //
// ./src/containers/home/Home.js